<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yap/about/abanner.png" alt="">
        </div>
        <div class="main">
            <div class="nav">
                <p class="wow fadeInDown" :class="{enp:$i18n.locale==='en'}">关于我们</p>
                <p class="wow fadeInDown">about us</p>
                <div class="link wow fadeInDown" :class="{enLink:$i18n.locale==='en'}">
                    <div v-for="(item,index) in $t('about').nList" :key="index" :class="{'active':select===index}" @click="change(index)">
                        {{item}}
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div class="company" v-if="select===0">
                    <div class="left wow">
                        <p class="p1">{{$t('about').nList[0]}}</p>
                        <p class="p2">Enterprise introduction</p>
                        <aboutDia />
                    </div>
                    <div class="right wow">
                        <img src="../assets/yap/about/right.png" alt="">
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="culture" v-if="select===1">
                    <div class="left">
                        <p class="p1">{{$t('about').nList[1]}}</p>
                        <p class="p2">corporate culture</p>
                        <div class="content">
                            <p class="t1">{{$t('about').text1}}</p>
                            <p class="t2">
                                {{$t('about').text2}}<br>
                                {{$t('about').text3}}<br>
                                {{$t('about').text4}}<br>
                                {{$t('about').text5}}<br>
                                {{$t('about').text6}}<br>
                                {{$t('about').text7}}
                            </p>
                        </div>
                    </div>
                    <div class="right">
                        <img src="../assets/yap/about/culture.png" alt="">
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="history" v-if="select===2">
                    <div class="right">
                        <img src="../assets/yap/about/rain.png" alt="">
                    </div>
                    <div class="left">
                        <homeDia />
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="honor" v-if="select===3">
                    <div class="text">
                       {{$t('about').honor[0]}}&nbsp;
                        {{$t('about').honor[1]}}&nbsp;
                        {{$t('about').honor[2]}}&nbsp;
                        {{$t('about').honor[3]}}&nbsp;
                        {{$t('about').honor[4]}}
                    </div>
                    <div class="allItems">
                        <div class="item wow fadeInUp" v-for="(item,index) in hList" :key="index" >
                            <div class="left">
                                <img :src="`http://www.eanper.com/upload/${item.SMALLPIC}`" alt="">
                            </div>
<!--                            <div class="right">-->
<!--                                <p>{{item.TITLE}}</p>-->
<!--                                <p>{{item.INTRO}}</p>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="btn" @click="showMore">
            <span>
                  MORE
            </span>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="service" v-if="select===4">
                    <div class="content">
                        <div class="text wow fadeInDown">
                            <p>{{$t('about').nList[4]}}</p>
                            <p>
                                　　{{$t('about').global.text0}}<br>
                                　　{{$t('about').global.text1}}
                            </p>
                        </div>
                        <div class="allItems">
                            <div class="item wow fadeInDown" style="animation-delay: 0.1s">
                                <div class="one">
                                    <i class="iconfont icon-fuwu"></i>
                                </div>
                                <p>{{$t('about').global.text2}}</p>
                            </div>
                            <div class="item wow fadeInDown" style="animation-delay: 0.2s">
                                <div class="one">
                                    <i class="iconfont icon-jiaoliu"></i>
                                </div>
                                <p>{{$t('about').global.text3}}</p>
                            </div>
                            <div class="item wow fadeInDown" style="animation-delay: 0.3s">
                                <div class="one">
                                    <i class="iconfont icon-zhinengyouhua"></i>
                                </div>
                                <p>{{$t('about').global.text4}}</p>
                            </div>
                            <div class="item wow fadeInDown" style="animation-delay: 0.4s">
                                <div class="one">
                                    <i class="iconfont icon-fuwuerji"></i>
                                </div>
                                <p>{{$t('about').global.text5}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="big2" v-if="showImg" @click="hide" id="ia" :style="dStyle">
            <img :src="src" alt="">
        </div>
        <foot-Component class="foot wow"></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import aboutDia  from "../components/aboutDia";
    import homeDia  from "../components/homeDia";
    import Scrollbar from 'smooth-scrollbar'
    import { getNewsUrl} from '../util/lang'
    export default {
        name: 'about',
        data(){
            return{
                src:'',
                showImg:false,
                dStyle:{},
                select:0,
                nList:[
                    "企业介绍",
                    "企业文化",
                    "发展历程",
                    "荣誉资质",
                    "全球化服务"
                ],
                id:'',
                page:'',
                totalPage:'',
                hList:[]
            }
        },
        components:{footComponent,aboutDia,swiper, swiperSlide,homeDia },
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,1)
            // window.pageYOffset=this.scrollbar.scrollTop
            this.scrollbar.addListener((status) => {
                this.dStyle={paddingTop:status.offset.y+200+'px'}
                window.pageYOffset=this.scrollbar.scrollTop
            });
            this.$nextTick(()=>{
                if(window.location.search.replace('?', '').split('=')[1]!==undefined){
                    this.getScroll(parseInt(this.getNid()))
                }
                if(this.$i18n.locale==='zh-CN'){
                    this.getNews('27')
                }else{
                    this.getNews('31')
                }

            })
        },
        methods:{
            getNews(id){
                this.id=id
                this.page=2
                const url = `${getNewsUrl(this.$i18n.locale,id,4,1)}`
                this.$axios.get(url).then(res => {
                    this.hList=res.data.newsArr
                    this.totalPage=res.data.pagerShow.totalPagers
                })
            },
            showMore(){
                if(this.page<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${getNewsUrl(this.$i18n.locale,this.id,4,this.page++)}`
                        this.$axios.get(url).then(res => {
                            this.hList= this.hList.concat(res.data.newsArr)
                        })
                    })
                }else{
                    this.$notify({
                        title: '提示',
                        message: '已经加载全部了',
                        offset: 100
                    });
                }
            },
            hide(){
                this.showImg=false
            },
            showBig(n){
                this.src='http://www.eanper.com/upload/'+n
                this.showImg=true
            },
            getNid () {
                return window.location.search.replace('?', '').split('=')[1].split('?')[0]
            },
            getScroll(n){
                this.select=n
            },
            change(n){
                const  link=`/about.html?index=${n}`
                window.open(link,'_self')
                // this.select=n
            },
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        animation: run5 1s linear forwards;
        position: relative;
        @keyframes run5 {
            from{
                opacity: 0;
            }
            to{
                opacity: 1;
            }
        }
        .banner{
            width:100%;
            position: relative;
            img{
                width:100%;
                object-fit: cover;
                display: block;
            }
        }
        .main{
            width:100%;
            margin: 30px auto;
            position: relative;
            .nav{
                width:1440px;
                margin: 0 auto;
                border-bottom: 2px solid rgba(0,0,0,.1);
                p{
                    text-align: right;
                    color:#666666;
                    animation-duration: 1s;
                }
                .enp{
                    opacity: 0;
                    animation: none;
                }
                p:nth-child(1){
                    font-size: 30px;
                    font-family: "Fira Code Medium";
                }
                p:nth-child(2){
                    font-size: 40px;
                    animation-delay: 1s;
                    text-transform: uppercase;
                    font-family: box;
                }
                .link{
                    width:100%;
                    animation-duration: 1s;
                    animation-delay:2s;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    color:#555555;
                    font-size: 14px;
                    margin: 0 auto;
                    div{
                        margin-left:30px;
                        font-family: "Fira Code Medium";
                        cursor: pointer;
                        position: relative;
                        padding: 10px 0;
                        &::after{
                            width:0;
                            height:2px;
                            background-color: #333333;
                            position: absolute;
                            left:0;
                            bottom:-1px;
                            content:'';
                            display: inline-block;
                            transition: all 1s;
                        }
                        &:hover::after{
                            width:100%;
                        }
                    }
                    .active::after{
                        width:100%;
                    }
                }
            }
            .company{
                width:1440px;
                margin: 20px auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding-bottom: 120px;
                .left{
                    width:49%;
                    animation: transition1 2s linear forwards;
                    .p1{
                        color:#333333;
                        font-size: 24px;
                        margin-bottom: 5px;
                        font-weight: bolder;
                        font-family: "Fira Code Medium";
                    }
                    .p2{
                        color:#333333;
                        font-size: 21px;
                        border-bottom: 2px solid rgba(0,0,0,.1);
                        padding-bottom: 10px;
                    }
                }
                .right{
                    width:49%;
                    overflow: hidden;
                    animation: transition2 2s linear forwards;
                    cursor: pointer;
                    img{
                        width:100%;
                        object-fit: cover;
                        display: inline-block;
                        transition: all 1s;
                    }
                    &:hover{
                        img{
                            transform: scale(1.05);
                        }
                    }
                }
            }
            .culture{
                @extend .company;
                .left{
                    .content{
                        .t1{
                            font-size: 30px;
                            margin: 25px auto;
                        }
                        .t2{
                            color:#333333;
                            font-size: 14px;
                            line-height: 35px;
                        }
                    }
                }
            }
            .history{
                @extend .company;
                .left{
                    padding-top: 30px;
                    animation: transition2 2s linear forwards;
                }
                .right{
                    animation: transition1 2s linear forwards;
                }
            }
            .honor{
                width:1440px;
                margin:60px auto;
                .text{
                    width:100%;
                    text-align: center;
                    line-height: 30px;
                }
                .allItems{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .item{
                        width:48.5%;
                        display: flex;
                        animation-duration: 2s;
                        flex-direction: row;
                        justify-content: center;
                        margin-top: 50px;
                        cursor: pointer;
                        .left{
                            width:40%;
                            text-align: center;
                            padding: 10px 0;
                            border: 1px solid #CDCDCD;
                            overflow: hidden;
                            img{
                                display: inline-block;
                                width:90%;
                                margin: 0 auto;
                                transition: all 1s;
                                filter: blur(1px);
                            }
                        }
                        .right{
                            width:48%;
                            p:nth-child(1){
                                color:#227CCB;
                                font-size: 18px;
                                padding-top: 100px;
                                padding-bottom: 30px;
                            }
                            p:nth-child(2){
                                color:#666666;
                                line-height: 30px;
                                font-family: "Fira Code Light";
                                font-weight: lighter;
                            }
                        }
                        &:hover{
                            .left{
                                img{
                                    transform: scale(1.05);
                                }
                            }
                        }
                    }
                }
                .btn{
                    width:352px;
                    height:50px;
                    border-radius:28px;
                    position: relative;
                    cursor: pointer;
                    overflow: hidden;
                    border: 1px solid #CDCDCD;
                    margin: 60px auto;
                    span{
                        position: absolute;
                        left:0;
                        top:0;
                        display: inline-block;
                        width:100%;
                        height:100%;
                        text-align: center;
                        transition: all 1s;
                        line-height: 50px;
                        color:#666666;
                        font-family: "Fira Code Light";
                        font-weight: lighter;
                    }
                    &::before{
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 150%;
                        height: 100%;
                        background: #37474f;
                        z-index: 0;
                        -webkit-transform: rotate3d(0, 0, 1, -45deg) translate3d(0, -3em, 0);
                        transform: rotate3d(0, 0, 1, -45deg) translate3d(0, -3em, 0);
                        -webkit-transform-origin: 0% 100%;
                        transform-origin: 0% 100%;
                        -webkit-transition: -webkit-transform 0.3s, opacity 0.3s, background-color 0.3s;
                        transition: all 1s;
                    }
                    &:hover{
                        span{
                            color:white;
                        }
                    }
                    &:hover::before{
                        opacity: 1;
                        background-color: #3f51b5;
                        -webkit-transform: rotate3d(0, 0, 1, 0deg);
                        transform: rotate3d(0, 0, 1, 0deg);
                        -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
                        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
                    }
                }
            }
            .service{
                width:100%;
                background: url("../assets/yap/about/service.png") no-repeat;
                background-size: cover;
                height:763px;
                margin: 20px auto;
                margin-bottom: 60px;
                .content{
                    width:1440px;
                    margin: 0 auto;
                    padding-top: 60px;
                    .text{
                        width:498px;
                        padding: 20px 20px;
                        margin: 0 auto;
                        animation-duration: 2s;
                        background:rgba(255,255,255,1);
                        box-shadow:0px 9px 0px 0px rgba(34,124,203,1);
                        position: relative;
                        p:nth-child(1){
                            padding-bottom: 20px;
                            color:#333333;
                            font-size: 24px;
                            text-align: center;
                        }
                        p:nth-child(2){
                            color:#333333;
                            font-size: 14px;
                            font-family: "Fira Code Light";
                            font-weight: lighter;
                            line-height: 30px;
                        }
                        &::before{
                            content:'';
                            display: inline-block;
                            position: absolute;
                            left:-30px;
                            top:-20px;
                            width:65px;
                            height:65px;
                            background:rgba(10,79,140,1);
                            border-radius:50%;
                        }
                        &::after{
                            content:'';
                            display: inline-block;
                            position: absolute;
                            left:15px;
                            top:10px;
                            width:37px;
                            height:37px;
                            background:rgba(34,124,203,1);
                            border-radius:50%;
                        }
                    }
                    .allItems{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin: 60px auto;
                        .item{
                            width:22%;
                            background-color: white;
                            padding: 20px 0;
                            display: flex;
                            animation-duration: 2s;
                            flex-direction: column;
                            align-items: center;
                            cursor: pointer;
                            transition: all 1s;
                            box-shadow:0px 10px 10px 0px rgba(210,210,210,0.7);
                            .one{
                                padding-bottom: 20px;
                                i{
                                    color:#227CCB;
                                    font-size: 60px;
                                    transition: all 1s;
                                }
                            }
                            p{
                                color:#333333;
                                width:90%;
                                margin-left: 5%;
                                font-size: 13px;
                                font-family: "Fira Code Light";
                                font-weight: lighter;
                                transition: all 1s;
                                line-height: 25px;
                            }
                            &:hover{
                                background-color: #227CCB;
                                .one{
                                    i{
                                        color:white;
                                    }
                                }
                                p{
                                    color:white;
                                }
                            }
                        }
                    }
                }
            }
        }
        .big2{
            position: absolute;
            width:100%;
            text-align: center;
            left:0;
            top:0;
            height:100%;
            background-color: rgba(0,0,0,.8);
            z-index: 1000;
            img{
                width:500px;
                object-fit: cover;
            }
        }
        .foot{
            animation-name: polygon;
            animation-duration: 1s;
        }
        @keyframes transition1 {
            0% {
                transform: translate(-300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(50% 0, 99% 50%, 50% 99%, 0 50%);
            }
            100% {
                clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
            }
        }
        @media screen and (max-width: 1440px) and (min-width: 1000px){
            .banner{
                img{
                    height:500px;
                }
            }
            .main{
                .nav,.company,.honor{
                    width:90%;
                }
                .service{
                    .content{
                        width:90%;
                    }
                }
            }
        }
        @media screen and (max-width: 1000px){
            .banner{
                img{
                    height:500px;
                }
            }
            .main{
                .nav{
                    width:95%;
                    p:nth-child(1){
                        font-size: 25px;
                    }
                    p:nth-child(2){
                        font-size: 32px;
                    }
                    .link{
                        div{
                            margin-left: 10px;
                        }
                    }
                    .enLink{
                       flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        div{
                            width:50%;
                            font-size: 14px;
                            text-align: center;
                        }
                    }
                }
                .company{
                    width:95%;
                    flex-direction: column;
                    margin: 40px auto;
                    .left,.right{
                        width:100%;
                    }
                    .left{
                        .p1{
                            font-size: 20px;
                        }
                    }
                }
                .culture{
                    .left{
                        .content{
                            .t1{
                                font-size: 22px;
                            }
                        }
                    }
                }
                .honor{
                    width:95%;
                    .allItems{
                        flex-direction: column;
                        .item{
                            width:100%;
                            flex-direction: column;
                            .left,.right{
                                width:100%;
                            }
                            .right{
                                p:nth-child(1){
                                    padding-top: 20px;
                                    padding-bottom: 10px;
                                }
                            }
                        }
                    }
                }
                .service{
                    height:auto;
                    padding-bottom: 20px;
                    .content{
                        width:95%;
                        .text{
                            width:70%;
                        }
                        .allItems{
                           flex-direction: column;
                            .item{
                                width:80%;
                                margin: 10px auto;
                            }
                        }
                    }
                }
            }
            .big2{
                img{
                    width:90%;
                    object-fit: contain;
                }
            }
        }
    }
</style>
